/* eslint-disable react/no-array-index-key */

import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';
import validate from './validate';
import { Title } from './style';
import RenderTextField from '../../../utils/renderFields/RenderTextField';
import { setSelectedOffer } from '../addCommandActions';

const CustomPaper = styled(Paper)`
  padding: 8px;
  background-color: ${props => props.color}
  cursor: pointer;
  text-align: center;
  font-size: 1.1em;
  font-weight: 500;
`;

const SelectedPricePaper = styled(Paper)`
  margin-bottom: 30px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 15px;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 40px;
`;

const NoDeliveryOffer = styled.div`
  text-align: center;
  font-size: 1.4em;
  font-weight: 400;
`;

const SubTitle = styled.div`
  margin-bottom: 6px;
  font-weight: bold;
`;

const CustomButton = styled(Button)`
  width: 130px;
`;

let RecipientInformationsStep = ({
  handleSubmit,
  getPrices,
  prices,
  insuranceAmount,
  previousPage,
  dispatchSetSelectedOffer,
  selectedOffer,
  pricesLoading
}) => {
  useEffect(() => {
    getPrices();
    // eslint-disable-next-line
  }, []);
  return (
    <form onSubmit={handleSubmit}>
      <Title>Sélectionner une offre de livraison</Title>
      {!pricesLoading && prices.length ? (
        <>
          <SelectedPricePaper>
            <div>
              <SubTitle>Assurance :</SubTitle>
              <Field
                name="insuranceAmount"
                label="Montant de la couverture"
                component={RenderTextField}
                style={{ width: 200 }}
                displayErrorBeforeSubmit
                fullWidth
                type="number"
              />
            </div>
            <div>
              {insuranceAmount > 300 ? (
                <div>
                  Coût de l&lsquo;assurance :{' '}
                  {Math.ceil(+insuranceAmount / 100 - 3) || 0} €
                </div>
              ) : (
                <div>Coût de l&lsquo;assurance : 0 €</div>
              )}
            </div>
          </SelectedPricePaper>
          <Grid container spacing={2} justify="center">
            {prices.map((price, index) => (
              <Grid
                item
                md={4}
                key={index}
                onClick={() => dispatchSetSelectedOffer(price)}
              >
                <CustomPaper
                  color={
                    price.offer.id === selectedOffer.offer.id
                      ? '#5dcaf463'
                      : '#fff'
                  }
                >
                  <div>{price.offer.shortName}</div>
                </CustomPaper>
              </Grid>
            ))}
          </Grid>
          <ButtonContainer>
            <CustomButton
              variant="contained"
              color="primary"
              onClick={previousPage}
            >
              Précédent
            </CustomButton>
            <CustomButton variant="contained" color="primary" type="submit">
              Expédier
            </CustomButton>
          </ButtonContainer>
        </>
      ) : null}
      {!pricesLoading && !prices.length ? (
        <>
          <NoDeliveryOffer>
            <p>Désolé nous n’avons aucune offre de livraison à vous proposez</p>
          </NoDeliveryOffer>
          <ButtonContainer>
            <CustomButton
              variant="contained"
              color="primary"
              onClick={previousPage}
            >
              Précédent
            </CustomButton>
          </ButtonContainer>
        </>
      ) : null}
    </form>
  );
};

const mapDipatchToProps = dispatch => ({
  dispatchSetSelectedOffer: offer => dispatch(setSelectedOffer(offer))
});

const mapStateToProps = state => {
  const selector = formValueSelector('addCommandForm');
  const insuranceAmount = selector(state, 'insuranceAmount');
  return {
    selectedOffer: state.addCommand.selectedOffer,
    pricesLoading: state.addCommand.pricesLoading,
    prices: state.addCommand.prices,
    insuranceAmount
  };
};

RecipientInformationsStep = reduxForm({
  form: 'addCommandForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(RecipientInformationsStep);

RecipientInformationsStep.propTypes = {
  handleSubmit: PropTypes.func,
  getPrices: PropTypes.func.isRequired,
  pricesLoading: PropTypes.bool.isRequired,
  insuranceAmount: PropTypes.string,
  previousPage: PropTypes.func.isRequired,
  dispatchSetSelectedOffer: PropTypes.func.isRequired,
  selectedOffer: PropTypes.object,
  prices: PropTypes.array
};

export default connect(
  mapStateToProps,
  mapDipatchToProps
)(RecipientInformationsStep);
